import { Box, Flex, Text } from '@chakra-ui/react';
import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { UserToken } from '@publishing-engine/domain/fixtures';
import { BMM_JOURNAL_ID, SUB_CTX_ID_MORRESSIER_JOURNAL } from '@publishing-engine/submission-service/src/fixtures/shared-ids';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AUTH_BEARER_TOKEN_KEY } from 'src/constants';
import useLocalStorage from 'src/hooks/useLocalStorage';

const FloatingNav = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [storedToken] = useLocalStorage<UserToken | null>(
    AUTH_BEARER_TOKEN_KEY,
    null
  );

  const [show, setShow] = useState(false);
  const showNav = () => setShow(true);
  const hideNav = () => setShow(false);

  const orgShortName = params?.shortname ?? 'awp';
  const ioppJournalId = params?.journalId ?? BMM_JOURNAL_ID;
  const morressierJournalId = SUB_CTX_ID_MORRESSIER_JOURNAL;

  const enableDevFeatures = false;
  if (!enableDevFeatures) {
    return null;
  }

  return (
    <Flex
      position="fixed"
      bottom={12}
      right={show ? 0 : '-180px'}
      transition="right 0.2s ease-in-out"
      alignItems="flex-end"
      onMouseEnter={showNav}
      onMouseLeave={hideNav}
      zIndex={1}
    >
      <Flex
        backgroundColor="surfacePrimaryFill"
        padding={2}
        height="36px"
        width="36px"
        justifyContent="center"
        alignItems="center"
      >
        <FontAwesomeIcon icon={faBars} />
      </Flex>
      <Box backgroundColor="surfacePrimaryFill" width="180px" borderRadius="sm">
        <Flex
          padding={4}
          flexDirection="column"
          gap={1}
          alignItems="flex-start"
        >
          <ButtonText variant="primary" onClick={() => navigate('/')}>
            Journals Lander
          </ButtonText>
          <Text textStyle="headingLine">Organization</Text>
          <ButtonText
            variant="primary"
            onClick={() => navigate(`/o/${orgShortName}`)}
          >
            Public Profile
          </ButtonText>
          <ButtonText
            variant="primary"
            onClick={() => window.location.href = `${window.location.origin}/iopp/j/${ioppJournalId}`}
          >
            IOPP Journal
          </ButtonText>
          <ButtonText
            variant="primary"
            onClick={() => window.location.href = `${window.location.origin}/m/j/${morressierJournalId}`}
          >
            Morressier Journal
          </ButtonText>

          {/* Logged in links */}
          {storedToken ? (
            <>
              <Text textStyle="headingLine">User</Text>
              <ButtonText variant="primary" onClick={() => navigate(`/app`)}>
                App Dashboard
              </ButtonText>
            </>
          ) : null}
        </Flex>
      </Box>
    </Flex>
  );
};

export default FloatingNav;
